import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import AssignmentRouter from './AssignmentRouter'
import { fetchAssignmentDetailByLin } from '../../actions/fetchAssignmentDetailAction'

import '../../style/assignments.scss'

class AssignmentContainer extends Component {
  componentDidMount() {
    this.props.fetchAssignmentDetailByLin(this.props.match.params.assignmentId)
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.assignmentDetails.fetching &&
        (this.props.match.params.assignmentId !== prevProps.match.params.assignmentId)) {
        this.props.fetchAssignmentDetailByLin(this.props.match.params.assignmentId)
    }
  }

  render() {
    return (
      <div className='assignment-container'>
        {this.props.assignmentDetails.fetching && this.props.assignmentDetails.lin && this.props.match.params.assignmentId !== this.props.assignmentDetails.lin &&
          <div className='assignment-loading'>Loading...</div>}
        {!this.props.assignmentDetails.fetching && this.props.assignmentDetails.error && (this.props.match.params[0] === 'search' ?
          <div className='assignment-error'>Error: Invalid case number or user is not authorized to access the case record.</div>
          : <div className='assignment-error'>Error: Unable to load assignment {this.props.match.params.assignmentId}.</div>)}
        {this.props.assignmentDetails.lin && this.props.match.params.assignmentId === this.props.assignmentDetails.lin &&
          <AssignmentRouter
            assignmentDetails={this.props.assignmentDetails}
            assignmentCorrespondence={this.props.assignmentCorrespondence}
            url={this.props.match.url}
            pathname={this.props.location.pathname}
            serverProperties={this.props.serverProperties} />}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  assignmentDetails: state.appraiser.assignments.assignmentDetails,
  assignmentCorrespondence: state.appraiser.assignments.assignmentCorrespondence,
  serverProperties: state.serverProperties ? state.serverProperties : {}
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ fetchAssignmentDetailByLin }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentContainer)
